"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWeatherCorrectedProduction = exports.useEstimatedProduction = exports.useBilledKwhLoading = exports.useBilledKwhError = exports.useBilledKwh = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var _orangeDataPoints = require("../reducers/orangeDataPoints");

/**
 *
 * @param {string} prospectId
 * @param {string} startDate
 * @param {string} endDate
 * @param {string} baseUrl
 * @param {string} authToken
 * @param {bool} enabled - if this is false, the call to the API's will not be made. This is
 * to allow the hook to be at the top level of a component without being nested in any if blocks
 * and still have it not make unneeded calls
 * @returns
 */
var useBilledKwh = function useBilledKwh(prospectId, startDate, endDate, baseUrl, authToken) {
  var _billedKwh$data;

  var enabled = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var dispatch = (0, _reactRedux.useDispatch)();
  var billedKwh = (0, _reactRedux.useSelector)((0, _orangeDataPoints.getOrangeDataPoints)(prospectId, startDate, endDate));
  (0, _react.useEffect)(function () {
    if (prospectId && authToken && baseUrl && enabled) {
      dispatch((0, _orangeDataPoints.fetchOrangeDataPointsIfNeeded)(prospectId, startDate, endDate, baseUrl, authToken));
    }
  }, [prospectId, startDate, endDate, enabled]);
  return billedKwh && (billedKwh === null || billedKwh === void 0 ? void 0 : (_billedKwh$data = billedKwh.data) === null || _billedKwh$data === void 0 ? void 0 : _billedKwh$data.map(function (billed) {
    return {
      billedKwh: billed.billedKwh,
      timestamp: billed.dateBilled
    };
  }));
};

exports.useBilledKwh = useBilledKwh;

var useEstimatedProduction = function useEstimatedProduction(prospectId, startDate, endDate, baseUrl, authToken) {
  var _estimatedProduction$;

  var enabled = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var dispatch = (0, _reactRedux.useDispatch)();
  var estimatedProduction = (0, _reactRedux.useSelector)((0, _orangeDataPoints.getOrangeDataPoints)(prospectId, startDate, endDate));
  (0, _react.useEffect)(function () {
    if (prospectId && authToken && baseUrl && enabled) {
      dispatch((0, _orangeDataPoints.fetchOrangeDataPointsIfNeeded)(prospectId, startDate, endDate, baseUrl, authToken));
    }
  }, [prospectId, startDate, endDate, enabled]);
  return estimatedProduction && (estimatedProduction === null || estimatedProduction === void 0 ? void 0 : (_estimatedProduction$ = estimatedProduction.data) === null || _estimatedProduction$ === void 0 ? void 0 : _estimatedProduction$.map(function (estimated) {
    return {
      estimatedKwhProduction: estimated.estimatedKwh,
      timestamp: estimated.dateBilled
    };
  }));
};

exports.useEstimatedProduction = useEstimatedProduction;

var useWeatherCorrectedProduction = function useWeatherCorrectedProduction(prospectId, startDate, endDate, baseUrl, authToken) {
  var _weatherCorrectedProd;

  var enabled = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var dispatch = (0, _reactRedux.useDispatch)();
  var weatherCorrectedProduction = (0, _reactRedux.useSelector)((0, _orangeDataPoints.getOrangeDataPoints)(prospectId, startDate, endDate));
  (0, _react.useEffect)(function () {
    if (prospectId && authToken && baseUrl && enabled) {
      dispatch((0, _orangeDataPoints.fetchOrangeDataPointsIfNeeded)(prospectId, startDate, endDate, baseUrl, authToken));
    }
  }, [prospectId, startDate, endDate, enabled]);
  return weatherCorrectedProduction && (weatherCorrectedProduction === null || weatherCorrectedProduction === void 0 ? void 0 : (_weatherCorrectedProd = weatherCorrectedProduction.data) === null || _weatherCorrectedProd === void 0 ? void 0 : _weatherCorrectedProd.map(function (weatherCorrected) {
    return {
      weatherCorrectKwhProduction: weatherCorrected.weatherCorrectedKwh,
      timestamp: weatherCorrected.dateBilled
    };
  }));
};

exports.useWeatherCorrectedProduction = useWeatherCorrectedProduction;

var useBilledKwhLoading = function useBilledKwhLoading() {
  var loading = (0, _reactRedux.useSelector)(_orangeDataPoints.getOrangeDataPointsLoading);
  return loading;
};

exports.useBilledKwhLoading = useBilledKwhLoading;

var useBilledKwhError = function useBilledKwhError() {
  var loading = (0, _reactRedux.useSelector)(_orangeDataPoints.getOrangeDataPointsError);
  return loading;
};

exports.useBilledKwhError = useBilledKwhError;